import React from 'react'
import { injectIntl } from 'react-intl'

const Address = ({intl}) => (
    <div>
        <div>
            <h3>Levain<br />Merikortteli</h3>

            <address>
                <a href="https://www.google.fi/maps/place/Pursimiehenkatu+29-31,+00150+Helsinki/" rel="noopener noreferrer">Pursimiehenkatu 29-31</a><br />
                00150 Helsinki
            </address>

            <a href="mailto:info.merikortteli@levain.fi">info.merikortteli@levain.fi</a>
            <a href="tel:+358103229384">{intl.locale==='en'?'+358 ':'0'}10 322 9384</a>

            <a href="https://www.facebook.com/LevainHelsinki/" className="some facebook">Facebook</a>
            <a href="https://www.instagram.com/levainhelsinki/" className="some instagram">Instagram</a>
        </div>
        <div>
            <h3>Levain<br />Töölö</h3>

            <address>
                <a href="https://www.google.fi/maps/place/Runeberginkatu+29,+00101+Helsinki/" rel="noopener noreferrer">Runeberginkatu 29</a><br />
                00100 Helsinki
            </address>

            <a href="mailto:info.toolo@levain.fi">info.toolo@levain.fi</a>
            <a href="tel:+358103229389">{intl.locale==='en'?'+358 ':'0'}10 322 9389</a>

            <a href="https://www.facebook.com/LevainHelsinki/" className="some facebook">Facebook</a>
            <a href="https://www.instagram.com/levainhelsinki/" className="some instagram">Instagram</a>
        </div>
        <div>
            <h3>Levain<br />Ullanlinna</h3>

            <address>
                <a href="https://www.google.fi/maps/place/Korkeavuorenkatu+21,+00130+Helsinki/" rel="noopener noreferrer">Korkeavuorenkatu 21</a><br />
                00130 Helsinki
            </address>

            <a href="mailto:info.ullanlinna@levain.fi">info.ullanlinna@levain.fi</a>
            <a href="tel:+358103232970">{intl.locale==='en'?'+358 ':'0'}10 323 2970</a>

            <a href="https://www.facebook.com/LevainHelsinki/" className="some facebook">Facebook</a>
            <a href="https://www.instagram.com/levainhelsinki/" className="some instagram">Instagram</a>
        </div>
    </div>
)

export default injectIntl(Address);


// WEBPACK FOOTER //
// ./src/components/Address.js